export enum ChainType {
  SOL = 'SOL',
  XLM = 'XLM',
  POLY = 'POLY',
  TRX = 'TRX',
  MATIC = 'MATIC',
  BASE = 'BASE',
}
